<template>
  <Row type="flex" align="top" :gutter="15" style="padding:10px 10px 0">
    <i-col :xs="24" :md="24" :lg="24" :sm="24"
      v-if="journal && 'education' in journal && journal.education && journal.education.length > 0"
      class="card-container" style="position:relative;margin-bottom:5px">
      <p style="color:red; margin-left: 0px; margin-bottom: 10px;"><b><span v-if="isCurrentUser">MY </span>EDUCATION</b></p>
      <!-- <Card class="card-list-item" :padding="10"> -->
        <ul class="listed-item padded red">
          <li v-for="(i,k) in journal.education" :key="k">
            <b>{{ i.name || i.text || i }}</b>
          </li>
        </ul>
      <!-- </Card> -->
    </i-col>
    <i-col :xs="24" :md="24" :lg="24" :sm="24"
      v-if="journal && 'accomplishment' in journal && journal.accomplishment && journal.accomplishment.length > 0"
      class="card-container" style="position:relative;margin-bottom:5px">
      <p style="color:red; margin-top: 16px; margin-bottom: 10px; margin-left: 0;"><b><span v-if="isCurrentUser">MY </span>CAREER HIGHLIGHTS</b></p>
      <!-- <Card class="card-list-item" :padding="10"> -->
        <ul class="listed-item padded red">
          <li v-for="(i,k) in journal.accomplishment" :key="k">
            <b>{{ i.name || i.text || i }}</b>
          </li>
        </ul>
      <!-- </Card> -->
    </i-col>

    <i-col :xs="24" :md="24" :lg="24" :sm="24"
      v-if="journal && 'notable' in journal && journal.notable && journal.notable.length > 0 "
      class="card-container" style="position:relative;margin-bottom:5px">
      <p style="color:red;  margin-top: 16px; margin-bottom: 10px; margin-left: 0;"><b><span v-if="isCurrentUser">MY </span> OTHER NOTABLE INFORMATION</b></p>
      <!-- <Card class="card-list-item" :padding="10"> -->
        <ul class="listed-item padded red">
          <li v-for="(i,k) in journal.notable" :key="k">
            <b>{{ i.name || i.text || i }}</b>
          </li>
        </ul>
      <!-- </Card> -->
    </i-col>
  </Row>
</template>

<script>
export default {
  props: {
    journal: {
      type: Object
    },
    isCurrentUser: {
      type: Boolean
    }
  },
  methods: {
    loadGroups() {
      // for future reference. don't remove, method is called somewhere in ViewPublicProfile component.
    }
  }
}
</script>
